<template>
	<component
		:is="tag"
		class="font-prenton-cond text-7xl tracking-xl uppercase lg:text-9xl lg:tracking-lg xl:text-10xl"
		:class="{'sr-only': isHidden}"
	>
		<slot></slot>
	</component>
</template>

<script lang="ts" setup>
withDefaults(
	defineProps<{
		tag?: string;
		isHidden?: boolean;
	}>(),
	{
		tag: "h2",
	},
);
</script>
